import { ModuleTaskOutput } from 'module/model/page/task/module-task.output';
import { ModuleTask } from 'module/page/task/module-task';

export abstract class ModuleTaskConverterPort {
	public abstract asModuleTask(output: ModuleTaskOutput): ModuleTask;
}
